import request, { sync } from '@/utils/request'
// 同步所有Spu->SkuGroup->Sku
export function esSyncSpuToEs () {
  return request({
    url: '/api/pms/admin/es/syncSpuToEs',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export const initMenuRedis = () => sync('/api/crm/admin/index/initMenuRedis')
export const saveSpecialToEs = () => sync('/api/pms/admin/es/saveSpecialToEs')
export const syncCategoryToEs = () => sync('/api/pms/admin/es/syncCategoryToEs')
export const syncComposeSizeGroupToEs = () => sync('/api/pms/admin/es/syncComposeSizeGroupToEs')
export const syncComposeSizeToEs = () => sync('/api/pms/admin/es/syncComposeSizeToEs')
export const syncDictToEs = () => sync('/api/pms/admin/es/syncDictToEs')
export const syncSpuPageNameToEs = () => sync('/api/pms/admin/es/syncSpuPageNameToEs')
export const syncThemeToEs = () => sync('/api/pms/admin/es/syncThemeToEs')
export const syncSpuFavorite = () => sync('/api/pms/admin/es/syncSpuFavorite')
export const syncMqSpuBleed = () => sync('/api/pms/admin/es/syncMqSpuBleed')
